const DYNAMIC_ROUTE_GROUPS: Array<[RegExp, string]> = [
  [/^\/steam-matches\/[^/]+$/, "/steam-matches/:shareCode"],
  [/^\/faceit-matches\/[^/]+$/, "/faceit-matches/:matchId"],
  [/^\/profile\/[^/]+$/, "/profile/:steamid"],
  [/^\/match\/[^/]+$/, "/match/:id"],
  [/^\/team-library\/[^/]+$/, "/team-library/:workspaceId"],
  [/^\/teams\/invite\/[^/]+$/, "/teams/invite/:token"],
];

const APP_ROUTE_PREFIXES = [
  "/home",
  "/profile",
  "/account",
  "/match-history",
  "/saved-replays",
  "/game-analysis",
  "/custom-analysis",
  "/win-probability",
  "/hall-of-fame",
  "/wall-of-shame",
  "/servers",
  "/steam-matches",
  "/faceit-matches",
  "/teams",
  "/team-library",
];

export function normalizeAnalyticsPath(pathname: string | null | undefined) {
  if (!pathname) return "/";

  const withoutQuery = pathname.split("?")[0] || "/";
  const normalized =
    withoutQuery.length > 1 ? withoutQuery.replace(/\/+$/, "") : withoutQuery;

  return normalized || "/";
}

export function getAnalyticsRouteGroup(pathname: string | null | undefined) {
  const normalized = normalizeAnalyticsPath(pathname);

  for (const [pattern, routeGroup] of DYNAMIC_ROUTE_GROUPS) {
    if (pattern.test(normalized)) {
      return routeGroup;
    }
  }

  return normalized;
}

export function isAppAnalyticsRoute(pathname: string | null | undefined) {
  const normalized = normalizeAnalyticsPath(pathname);
  return APP_ROUTE_PREFIXES.some(
    (route) => normalized === route || normalized.startsWith(`${route}/`)
  );
}

export function getAnalyticsProductSurface(params: {
  pathname: string | null | undefined;
}) {
  return isAppAnalyticsRoute(params.pathname) ? "app" : "site";
}
